module.exports = __webpack_public_path__ + "img/nav-assets.6950a8a.svg";